import _extends from '@babel/runtime/helpers/extends';
import React__default, { useContext } from 'react';
import styled from 'styled-components';
import { A as Alert } from '../../Alert/Alert-CeGIJhfJ.js';
import { B as Button } from '../../Button/Button-BzSULnj6.js';
import { F as FileUploadContext } from '../FileUploadContext-CI9_em1Z.js';
import { u as upload } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const Container = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-1r47fzf-0"
})(["display:", ";width:", ";&& > button{width:", ";}"], ({
  $fullWidth
}) => $fullWidth ? 'block' : 'inline-block', ({
  $fullWidth
}) => $fullWidth ? '100%' : 'auto', ({
  $fullWidth
}) => $fullWidth ? '100%' : 'auto');
const CriteriaListContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-1r47fzf-1"
})(["margin-top:", ";color:", ";"], ({
  theme
}) => theme.fileUploadButton.criteriaListContainer.marginTop.default, ({
  theme
}) => theme.text.color.secondary);
const UploaderAlert = /*#__PURE__*/styled(Alert).withConfig({
  componentId: "sc-storm-ui-40027066__sc-1r47fzf-2"
})(["margin-top:", ";"], ({
  theme
}) => theme.spacing.xxsmall.default);
const FileUploadButton = ({
  label,
  hideLabel = false,
  icon,
  ...rest
}) => {
  const {
    description,
    disabled,
    errorText,
    fullWidth,
    inputRef,
    onCloseAlert
  } = useContext(FileUploadContext);
  const handleClick = event => {
    event.preventDefault();
    if (inputRef !== null && inputRef !== void 0 && inputRef.current) {
      /** Reset the value of the input so
       * duplicate files are not ignored */
      inputRef.current.value = '';
      inputRef.current.click();
    }
  };
  return /*#__PURE__*/React__default.createElement(Container, {
    $fullWidth: fullWidth
  }, /*#__PURE__*/React__default.createElement(Button, _extends({}, rest, {
    disabled: disabled,
    onClick: handleClick,
    "aria-label": hideLabel ? label : undefined,
    iconStart: icon !== null && icon !== void 0 ? icon : upload
  }), !hideLabel && label), description && /*#__PURE__*/React__default.createElement(CriteriaListContainer, null, description), errorText && /*#__PURE__*/React__default.createElement(UploaderAlert, {
    variant: "error",
    role: "alert",
    withCloseButton: true,
    onClick: onCloseAlert
  }, errorText));
};

export { FileUploadButton as F };
//# sourceMappingURL=FileUploadButton-DWuAjbN_.js.map
